import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { CoreHttpClient } from "../../http-client/http-client.service";

import { GoogleAuthTransactionConfigService } from "./google-auth-transaction.config";
import { OPEN_ID_CONNECT_CURRENT_JOURNEY_KEY } from "./google-auth-transaction.const";
import { OpenIdConnectResponse } from "./google-auth-transaction.model";

@Injectable({
	providedIn: "root",
})
export class GoogleAuthTransactionService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: GoogleAuthTransactionConfigService
	) {}

	getOpenIdConnectUrl(): Observable<OpenIdConnectResponse> {
		return this.httpClient.get<OpenIdConnectResponse>({
			url: this.config.getOpenIdConnectUrlEndpoint(),
			searchParams: { provider: "google" },
		});
	}

	setCurrentJourney(provider: string): void {
		sessionStorage.setItem(OPEN_ID_CONNECT_CURRENT_JOURNEY_KEY, provider);
	}
}
